import { HomeFloor3Icon } from './HomeFloor3Icon';

/**
 * author: GreenTurtwig
 * id E7714A6B-EE3B-4819-81B8-1E9FF342598F
 * name home-floor-3
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-3.svg
 * tags
 * - Home Automation 
 */
export const HomeFloorThirdIcon = HomeFloor3Icon;
export default HomeFloorThirdIcon